import { render, staticRenderFns } from "./ResearchBoxPlotVector.vue?vue&type=template&id=6857ec88"
import script from "./ResearchBoxPlotVector.vue?vue&type=script&lang=js"
export * from "./ResearchBoxPlotVector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6857ec88')) {
      api.createRecord('6857ec88', component.options)
    } else {
      api.reload('6857ec88', component.options)
    }
    module.hot.accept("./ResearchBoxPlotVector.vue?vue&type=template&id=6857ec88", function () {
      api.rerender('6857ec88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/vectorPlots/ResearchBoxPlotVector.vue"
export default component.exports